<!-- 全局经纪人选择组件：下拉框选择部门与经纪人 -->
<template>
  <el-cascader 
    v-model="belong" 
    v-bind="attributes"
    :options="departmentList"
    :key="'ag_selector_' + isResouceShow" 
    :clearable="clearable" 
    :disabled="disabled"
    @change="handleChange" 
    ref="agentSelectorRef" 
  >
    <template slot-scope="{ node, data }">
      <span >{{ data.name }}</span>
      <span v-if="data.type == 'member' && data.mobile">-{{ data.mobile }}</span>
      
      
    </template>
  </el-cascader>
</template>
<script>
import {getAllCompanyMemberByAdmin, getAllCompanyMember} from '@/api/base';
import { mapState } from 'vuex';
const defaultAttr = {
  'placeholder': '请选择',
  'props': {
    checkStrictly: true,
    emitPath: false, // 这个地方必须为false,否则会导致下面数据渲染失败
    expandTrigger: 'hover',
    value: 'id', 
    label: 'name'
  },
  'show-all-levels': false
}
export default{
  name: 'AgentSelector',
  props: {
    value: Object,
    // 经纪人权限类型(必填) 1:当前登录用户权限下的部门与人员   2:整个公司的部门与人员
    agentType: Number,
    // 经纪人接口请求参数(非必填)
    paramters: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 下拉框内容是否从公司节点开始选择(非必填)
    isRoot: {
      type: Boolean,
      default: false
    },
    onlyShowActive: {
      type: Boolean,
      default: false
    },
    // 下拉框内容是否添加全部选项(非必填)
    isAll: {
      type: Boolean,
      default: false
    },
    // 是否可以清空(非必填)
    clearable: {
      type: Boolean,
      default: true
    },
    // 是否禁用(非必填)
    disabled: {
      type: Boolean,
      default: false
    },
    onlyAgent:{
      type: Boolean,
      default: false
    }

  },
  data () {
    return {
      belong: [],
      departmentList: [],
      attributes: {}, // 下拉框配置项：输入attrs + 默认attrs
      isResouceShow: 0 // 重复递增：解决elementUI el-cascader组件key值问题
    }
  },
  computed: {
    ...mapState({
      firmInfo: state => state.user.companyInfo
    }),
    getUrl () {
      if (this.agentType == 1) return getAllCompanyMemberByAdmin;
      if (this.agentType == 2) return getAllCompanyMember;
      return () => {}
    }
  },
  watch: {
    value: {
      handler: function(val, oldVal) {
        if (!val) return null;
        // 判断传入值与当前值是否一样
        if (JSON.stringify(val) === JSON.stringify(this.result)) return null;
        // 绑定值
        this.belong = Number(val.admin_id || val.dept_id);
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    this.attributes = {
      ...defaultAttr,
      ...this.$attrs
    }
    this.initData();
  },
  methods: {
    async initData () {
      this.isResouceShow += 1;
      try {
        if(this.onlyShowActive){
          this.paramters.is_active  = 0
        }
        const res = await this.getUrl(this.paramters);
        let list = res || [];
        if(this.onlyAgent){
          list = list.map(val=>{
              if(val.children && val.children.length){
                  val.children.map(d=>{
                    if(d.children && d.children.length){
                      d.children.map(n=>{
                        n.disabled= n.type == 'department'
                        return n
                      })
                      return d
                    } 
                    return d
                })
                return val
              }
              return val
          })
        }
        // 添加公司根节点
        if (this.isRoot) {
          list = [{
            id: -2,
            name: this.firmInfo.name,
            children: list
          }]
        }
        // 添加全部选项
        if (this.isAll) {
          list.unshift({
            id: -1,
            name: '全部',
            type: 'member'
          })
        }
        this.departmentList = list;
      } catch (error) {
        console.log('获取部门筛选列表错误：', error);
      }
    },
    // change回调：输送选中内容
    handleChange (e) {
      // 获取选中内容
      const checkNodes = this.$refs.agentSelectorRef.getCheckedNodes();
      const node = checkNodes && checkNodes[0] && checkNodes[0].data || null;
      let data = null;
      // 拼接当前选中数据
      if (node && node.type === 'member') {
        data = {admin_id: node.id};
      } else if (node && node.type === 'department') {
        data = {dept_id: node.id};
      }
      // 事件回传
      this.result = data;
      this.$emit('input', data);
      this.$emit('change', data);
    }
  },
}
</script>